import { Fieldset as Fieldsets } from 'primereact/fieldset';  

const Fieldset = ({...rest}) => {

    return (
        <Fieldsets {...rest} />
    )

};

export default Fieldset;